import Image from "next/image";
import Link from "next/link";
import ArrowLink from "./ArrowLink";

type Props = {
	imageSrc: string;
	imageAlt: string;
	title: string;
	subtitle?: string;
	linkHref: string;
	linkText: string;
	tags?: {
		name: string;
		slug?: string;
	}[];
	teamCard?: boolean;
};

const ListingCard = ({ imageSrc, imageAlt, title, subtitle, linkHref, linkText, tags, teamCard = false }: Props) => {
	return (
		<div className="group grid h-full overflow-hidden">
			<div className="border-l-3 border-navy mr-3 flex flex-col pl-3 lg:mr-0 lg:gap-6 lg:pl-[1.875rem]">
				{imageSrc && (
					<Link href={linkHref} className="overflow-hidden">
						<Image
							src={imageSrc}
							alt={imageAlt}
							width={800}
							height={800}
							className="duration-500 group-hover:scale-105"
						/>
					</Link>
				)}
				{tags && (
					<div className={`to-lg:mt-5 flex flex-wrap gap-2 lg:gap-[0.625rem] ${teamCard ? "lg:-mb-4 lg:mt-1" : ""}`}>
						{tags.map((tag, i) => ({
							...(tag.slug ? (
								<Link key={i} className="tag-pill" href={tag.slug}>
									{tag.name}
								</Link>
							) : (
								<div key={i} className="tag-pill">
									{tag.name}
								</div>
							)),
						}))}
					</div>
				)}
				<h3 className={`to-lg:mt-1 text-lg lg:text-xl ${teamCard ? "leading-none" : "leading-tight"}`}>{title}</h3>
				{subtitle && <p className={`text-base ${teamCard ? "lg:-mt-4" : ""}`}>{subtitle}</p>}
				{linkHref && linkText && (
					<ArrowLink className={`to-lg:pt-9 mt-auto ${teamCard ? "mt-6" : ""}`} href={linkHref} text={linkText} />
				)}
			</div>
		</div>
	);
};

export default ListingCard;
